module.exports = __webpack_public_path__ + "img/thank_2021_tip5_mall.5d2c475b.png";